import { axios } from "../../config/axios";

export const anylinkAPI = {
  /**
   * Get all anylinks from a communication
   * @param {string} communicationType
   * @param {number} communicationId
   * @returns {array} Array of anylinks ordered by priority
   */
  getAnyLinks(communicationType, communicationId) {
    return axios.get(`/api/v3/${communicationType}/${communicationId}/any_links`)
                .then((resp) => resp.data);
  },
  /**
   * Get Previously used anylinks
   * @returns {array} Array of most recent previously used anylinks (max. 10) ordered by update date
   */
   getPreviouslyUsedAnyLinks() {
    return axios.get("/api/v3/current_merchant/any_links")
                .then((resp) => resp.data);
   },
   removePreviouslyUsedAnyLink(linkId) {
    return axios.delete("/api/v3/current_merchant/any_links", { data: { any_link_id: linkId }});
   },
  /**
   * PUT to update anyLinks for a communication
   * @param {string} communicationType
   * @param {number} communicationId
   * @param {array} anyLinks
   * @returns {object} status code 200 if successful or error
   */
  putUpdateAnyLinks(communicationType, communicationId, anyLinks) {
    const formData = new FormData()

    anyLinks.forEach(anyLink => {
      formData.append("any_links[][title]", anyLink.title);
      formData.append("any_links[][url]", anyLink.url);
      formData.append("any_links[][priority]", anyLink.priority);

      if(anyLink.thumbnail) {
        if (anyLink.thumbnail.attachment_id) {
          formData.append("any_links[][thumbnail][url]", anyLink.thumbnail.url);
          formData.append("any_links[][thumbnail][attachment_id]", anyLink.thumbnail.attachment_id);
        } else {
          formData.append("any_links[][thumbnail]", anyLink.thumbnail);
        }
      }
    })

    return axios.put(`/api/v3/${communicationType}/${communicationId}/any_links`, formData)
                .then((resp) => resp);
  }
}
